import * as React from "react";

function TechSvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={36.582}
      height={30.485}
      {...props}
    >
      <path
        d="M13.718 18.291H6.097a1.524 1.524 0 01-1.524-1.524V6.097a1.524 1.524 0 011.524-1.524h7.621a1.524 1.524 0 011.525 1.524v10.67a1.524 1.524 0 01-1.525 1.524zM29.723 7.621H18.291a1.524 1.524 0 010-3.048h11.432a1.524 1.524 0 110 3.048zM28.199 15.245h-9.908a1.524 1.524 0 01-1.524-1.527v-3.049a1.524 1.524 0 011.524-1.524h9.908a1.524 1.524 0 011.524 1.524v3.048a1.524 1.524 0 01-1.524 1.528zm-8.383-3.048z"
        fill="#ff7b16"
      />
      <path
        d="M33.914 0H2.667A2.67 2.67 0 000 2.667v20.578a2.67 2.67 0 002.667 2.667h31.247a2.67 2.67 0 002.667-2.667V2.667A2.67 2.67 0 0033.914 0zm-.381 19.815H3.048V3.048h30.485z"
        fill="#ff7b16"
      />
      <path
        d="M24.165 29.188a6.355 6.355 0 01-2.064-4.038.762.762 0 00-.762-.762h-6.127a.766.766 0 00-.762.767 6.208 6.208 0 01-2.032 4.033.762.762 0 00.538 1.3h10.67a.763.763 0 00.54-1.3z"
        fill="#ff7b16"
      />
    </svg>
  );
}

export default TechSvg;
